import { ActionDefinition, ActionState, AssetState } from '../types';
import { get, set } from '../cas/module';
import findAttribute from '../sceneGraph/findAttribute';

const propagateAttribute: ActionDefinition = {
  supports: ['material', 'model', 'scene', 'texture'],
  label: 'Set Model',
  schema: {
    attributeId: {
      type: 'Attribute',
      label: 'Attribute',
      acceptArrayValue: false,
    },
    path: { type: 'Path', label: 'Property' },
    name: { type: 'String', label: 'Child Attribute Name' },
  },

  update: (
    input: ActionState,
    args: { attributeId: string; path: any; name: string }
  ) => {
    const { attributeId, path, name } = args;
    if (!attributeId || !name) return input;
    const { attr } = findAttribute(
      input.evaluatedAsset.attributes,
      attributeId
    );
    if (!attr) return input;

    const assetRef = get(input.assetState, path);
    if (!assetRef || !assetRef.assetId) {
      console.error('Invalid reference for propagation', path);
      return input;
    }
    const value = input.configuration[attr.name];

    const configuration = Object.assign({}, assetRef.configuration ?? {});
    configuration[name] = input.configuration[attr.name];

    return {
      ...input,
      assetState: set(input.assetState, path, { ...assetRef, configuration }),
    };
  },
};

export default propagateAttribute;
